import ko from '@tko/build.knockout';
import _ from 'lodash';
import Vue from 'vue';
import vuetify from '../../../../plugins/vuetify';
import MenuIcons from '../../../../app/helpers/menu-icons';
import CreateAccount from '../../components/createAccount/createAccount.vue';
import templateMarkup from 'raw-loader!./create-account.html';

class CreateAccountView {
    constructor(params) {
        let self = this;

        this.vueCreateAccount = new Vue({
            el: '#vueCreateAccount',
            vuetify,
            render: h => h(CreateAccount)
        });
    }

    dispose() {
        if (this.vueCreateAccount) {
            this.vueCreateAccount.$destroy();
            this.vueCreateAccount.$el.parentNode.removeChild(this.vueCreateAccount.$el);
        }
    }
}

ko.components.register('create-account-view', { template: templateMarkup, viewModel: CreateAccountView });

export default { template: templateMarkup, viewModel: CreateAccountView }
